import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ScrollText, Clock } from "lucide-react";

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/audit-logs?limit=300").then(r => setLogs(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-[#64748B]">System</div>
        <h1 className="text-3xl tracking-tighter font-medium mt-1">Audit Log</h1>
        <p className="text-[#475569] text-sm mt-1">All actions are recorded with actor, timestamp and context.</p>
      </div>
      {loading ? <div className="text-sm text-[#475569]">Loading…</div> :
        logs.length === 0 ? (
          <div className="text-center py-16 text-[#64748B] border border-dashed border-[#E5E7EB] rounded-xl">
            <ScrollText size={28} className="mx-auto mb-3" /> No audit events yet.
          </div>
        ) : (
          <div className="rounded-xl border border-[#E5E7EB] bg-[#FFFFFF] overflow-hidden">
            <table className="w-full text-sm" data-testid="audit-table">
              <thead><tr className="border-b border-[#E5E7EB] text-left">
                {["Time", "Actor", "Action", "Entity", "Details"].map(h =>
                  <th key={h} className="px-4 py-3 text-[10px] uppercase tracking-[0.18em] text-[#64748B] font-bold">{h}</th>)}
              </tr></thead>
              <tbody>{logs.map(l => (
                <tr key={l.id} className="border-b border-[#E5E7EB] hover:bg-[#F8FAFC]">
                  <td className="px-4 py-3 text-xs text-[#64748B] whitespace-nowrap">
                    <Clock size={10} className="inline mr-1" />{fmt(l.created_at)}
                  </td>
                  <td className="px-4 py-3 text-xs">{l.actor_role || "system"}</td>
                  <td className="px-4 py-3 font-mono text-xs text-[#E63946]">{l.action}</td>
                  <td className="px-4 py-3 text-xs">{l.entity_type}</td>
                  <td className="px-4 py-3 text-xs text-[#475569] truncate max-w-md">{JSON.stringify(l.details).slice(0, 100)}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        )}
    </div>
  );
}
function fmt(d) { if (!d) return "-"; try { return new Date(d).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }); } catch { return d; } }
